import { inject } from 'vue'
import { logExceptionKey } from '@shared/plugins/log-exception'

/**
 * Only use this for vue composition API setup functions.
 * Because inject() can only be used inside setup() or functional components.
 * For vue options API, use `this.$logException` instead.
 *
 * This composable simplifies usage by handling injection key imports and inject() calls automatically
 * while ensuring the logException function is properly provided.
 */
export function useLogException() {
  const logException = inject(logExceptionKey)

  if (!logException) throw new Error('logException not provided')

  return { logException }
}
